import { useEffect, useState } from 'react';

// Returns a copy of `value` that only updates after `delayMs` of no changes —
// use it to drive expensive work (filtering, match counts) off fast-changing
// inputs like search text without running on every keystroke.
export default function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
